import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import ExemptionsViewModel from "viewModels/callCenter/search/exemptions/exemptionsViewModel";
import { toolbarContext } from "../searchResultsView";

const ExemptionsToolbarView: ViewComponent<ExemptionsViewModel> = observer(({ vm }) => {
  if (!vm.allowWrite) {
    return null;
  }

  return (
    <ButtonToolbar className="align-self-center ml-auto">
      <Button variant="primary" className="rounded" size="sm" iconLeft={IconType.SignPlus} onClick={vm.onAddExemptionClick}>
        {vm.translate("exemptions.add")}
      </Button>
    </ButtonToolbar>
  );
});

registerView(ExemptionsToolbarView, ExemptionsViewModel, toolbarContext);
